module.exports = __webpack_public_path__ + "static/media/kitty3.7b7aed73.jpg";